<template>
  <svg viewBox="0 0 24 24" fill="none" :stroke="stroke" stroke-width="2">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
</template>

<script setup>
defineProps({
  stroke: {
    type: String,
    default: 'currentColor'
  }
})
</script>
